var MenuSolutions = (function () {

    var $ = require('jquery');
    var self = {};

    self.$menuItem = $('[data-menu-child-ref]');
    self.highlightedClassName = 'current-menu-item';

    self.init = function () {

        require('./../../../../build/node_modules/@components/jquery-mmenu/dist/jquery.mmenu.js');

        $('.mmenu').mmenu({
            'offCanvas': false
        });

        self.$menuItem.on('mouseenter', function () {

            var $this = $(this);
            var childMenuID = $this.data('menu-child-ref');

            //  Remove all highlighted menu items and hide all children
            self.$menuItem.parent().removeClass(self.highlightedClassName);
            $('.child-menu').removeClass(self.highlightedClassName);

            //  Highlight the clicked menu (li)
            $this.parent().addClass(self.highlightedClassName);

            //  Find matching child menu
            $('#menu-' + childMenuID).addClass(self.highlightedClassName);

            //  Add class to body to animate the menu
            App.Globals.$body.addClass('menu-solutions-extra-open');
        });

        $('.button-menu-solutions').on('mouseleave', function () {

            var $this = $(this);
            var childMenuID = $this.data('menu-child-ref');

            //  Remove all highlighted menu items and hide all children
            self.$menuItem.parent().removeClass(self.highlightedClassName);
            $('.child-menu').removeClass(self.highlightedClassName);

            //  Remove the highlight from the clicked menu (li)
            $this.parent().removeClass(self.highlightedClassName);

            //  Remove matching child menu
            $('#menu-' + childMenuID).removeClass(self.highlightedClassName);

            //  Remove class from body to animate the menu
            App.Globals.$body.removeClass('menu-solutions-extra-open');
        });

    };

    return self;

}());

module.exports = MenuSolutions;
